import { CLIENTS } from "../data/content";
import { Reveal, PageHeader, QuoteCTA, Marquee } from "../components/Shared";

export default function Clients() {
  return (
    <div data-testid="clients-page">
      <PageHeader
        tag="Clients"
        title={<>Brands That<br />Trust the Craft.</>}
        subtitle="From single-location storefronts to national retail programs — sample client showcase shown below; your real client list and logos can be swapped in anytime."
      />

      <section className="pb-20">
        <div className="msg-container">
          <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l" style={{ borderColor: "var(--line)" }} data-testid="clients-grid">
            {CLIENTS.map((c, i) => (
              <Reveal key={c.name} delay={i * 0.05}>
                <div
                  className="group p-10 border-r border-b h-full flex flex-col justify-center items-center text-center transition-colors hover:bg-[var(--bg-2)]"
                  style={{ borderColor: "var(--line)" }}
                  data-testid={`client-card-${i}`}
                >
                  <p className="font-display font-black uppercase text-lg lg:text-xl tracking-tight transition-colors group-hover:text-[var(--brand-cyan)]">{c.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase mt-3" style={{ color: "var(--text-3)" }}>{c.sector}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Marquee />

      <section className="py-24" data-testid="clients-testimonial-section">
        <div className="msg-container grid grid-cols-1 lg:grid-cols-3 gap-8">
          {[
            { quote: "MSG handled our 40-store display rollout without a single missed deadline. The finish quality was above anything we'd received before.", who: "Retail Operations Director", color: "var(--brand-orange)" },
            { quote: "From the site survey to the final install, one team owned everything. Our storefront has never looked this good at night.", who: "Franchise Owner, Vaughan", color: "var(--brand-magenta)" },
            { quote: "They caught structural issues in our display design before production and fixed them at no charge. That's a real manufacturing partner.", who: "Brand Manager, CPG", color: "var(--brand-cyan)" },
          ].map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure className="msg-card p-8 h-full relative overflow-hidden">
                <span className="absolute top-0 left-0 w-full h-1" style={{ background: t.color }} />
                <blockquote className="text-base leading-relaxed mt-2" style={{ color: "var(--text-2)" }}>"{t.quote}"</blockquote>
                <figcaption className="font-mono text-xs tracking-wider uppercase mt-6" style={{ color: t.color }}>— {t.who}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
